/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'

import styles from './containers/WGCWXShopProducts/components/WGCWXShopCard/WGCWXShopCard.scss'

export const AFFIRMATIVE = (
    <FormattedMessage
        id='wgcwx_shop.affirmative'
        defaultMessage='Так точно!'
    />
)

export const NO = (
    <FormattedMessage
        id='wgcwx_shop.no'
        defaultMessage='Нет'
    />
)

export const PURCHASE = (
    <FormattedMessage
        id='wgcwx_shop.purchase'
        defaultMessage='Получить'
    />
)

export const CURRENCY_TO_SPEND = currency => (
    <FormattedMessage
        id='wgcwx_shop.currency_to_spend'
        defaultMessage='К обмену: {currency}'
        values={{ currency }}
    />
)

export const CURRENCY_LEFT = currency => (
    <FormattedMessage
        id='wgcwx_shop.currency_left'
        defaultMessage='На вашем счету останется: {currency}'
        values={{ currency }}
    />
)

export const BACK_TO_MAIN = (
    <FormattedMessage
        id='wgcwx_shop.back_to_main'
        defaultMessage='К бонусам'
    />
)

export const PREMIUM_BONUSES_NOT_AVAILABLE_YET = (
    <FormattedMessage
        id='wgcwx_shop.premium_bonuses_unavailable'
        defaultMessage='Получение призов станет доступно через некоторое время после завершения события.'
    />
)

const TANK_CARD_SELECTION_TOP = topPlaces => (
    <FormattedMessage
        id='wgcwx_shop.tank_purchase.top'
        defaultMessage='топ-{top}'
        values={{ top: <FormattedNumber value={topPlaces} /> }}
    />
)

export const TANK_PURCHASE_REQUIREMENT_SHORT = topPlaces => (
    <FormattedMessage
        id='wgcwx_shop.tanks_purchase.requirement.short'
        defaultMessage='Технику за фиксированное количество бон смогут получить игроки, вошедшие в {top} по итогам события.'
        values={{
            top: (
                <span className={styles.highlight}>
                    {TANK_CARD_SELECTION_TOP(topPlaces)}
                </span>
            ),
        }}
    />
)

export const TANK_PURCHASE_REQUIREMENT_DETAILED = topPlaces => (
    <FormattedMessage
        id='wgcwx_shop.tanks_purchase.requirement.detailed'
        defaultMessage='Технику за фиксированное количество бон смогут получить игроки, вошедшие в {top} по итогам события. Остальные игроки получат возможность участвовать в боновом аукционе. Необходимое количество личных Очков славы для получения техники станет известно после завершения события.'
        values={{
            top: (
                <span className={styles.highlight}>
                    {TANK_CARD_SELECTION_TOP(topPlaces)}
                </span>
            ),
        }}
    />
)

export const TANK_STYLE_DESCRIPTION = (
    <FormattedMessage
        id='wgcwx_shop.tanks_style_pack'
        defaultMessage='Выбранная призовая машина будет начислена вместе с набором кастомизации «Ветеран»'
    />
)

export const STYLE_IS_IN_INVENTORY_ALREADY = (
    <FormattedMessage
        id='wgcwx_shop.tanks_style_is_in_inventory_already'
        defaultMessage='У вас уже есть этот стиль'
    />
)

export const GROUP_CAPTIONS = {
    ussr: (
        <FormattedMessage
            id='nations_select.captions.ussr'
            defaultMessage='СССР'
        />
    ),
    germany: (
        <FormattedMessage
            id='nations_select.captions.germany'
            defaultMessage='Германия'
        />
    ),
    usa: (
        <FormattedMessage
            id='nations_select.captions.usa'
            defaultMessage='США'
        />
    ),
    china: (
        <FormattedMessage
            id='nations_select.captions.china'
            defaultMessage='Китай'
        />
    ),
    france: (
        <FormattedMessage
            id='nations_select.captions.france'
            defaultMessage='Франция'
        />
    ),
    uk: (
        <FormattedMessage
            id='nations_select.captions.uk'
            defaultMessage='Великобритания'
        />
    ),
    japan: (
        <FormattedMessage
            id='nations_select.captions.japan'
            defaultMessage='Япония'
        />
    ),
    czech: (
        <FormattedMessage
            id='nations_select.captions.czech'
            defaultMessage='Чехословакия'
        />
    ),
    sweden: (
        <FormattedMessage
            id='nations_select.captions.sweden'
            defaultMessage='Швеция'
        />
    ),
    poland: (
        <FormattedMessage
            id='nations_select.captions.poland'
            defaultMessage='Польша'
        />
    ),
    italy: (
        <FormattedMessage
            id='nations_select.captions.italy'
            defaultMessage='Италия'
        />
    ),
}

export const getTooltipTitleForGroup = (filterGroup) => GROUP_CAPTIONS[filterGroup]



// WEBPACK FOOTER //
// ./containers/WGCWXShop/translations.jsx